const locale = {
	VIEW_ITEM_BUTTON_COMPANIES_MERGE: 'Combina Aziende',
	COMPANIES_MERGE_DIALOG_TITLE: 'Combina Aziende',
	COMPANIES_MERGE_DIALOG_DESCRIPTION:
		'Trasferisci TUTTI i campi dell\'anagrafica (eccetto il titolo) e gli elementi collegati (Persone, Attività, Opportunità, ecc.) dall\'Azienda indicata come "Azienda da sostituire", la quale verrà bloccata con il motivo specificato nel campo "Motivo".',
	COMPANIES_MERGE_DIALOG_FIELD_COMPANY: 'Azienda da sostituire',
	COMPANIES_MERGE_DIALOG_FIELD_REASON: 'Motivo',

	COMPANIES_DUPLICATE_ALERT_DIALOG_TITLE:
		"{count, plural, one {Trovata un'Azienda simile} other {Trovate # Aziende simili}}",
	COMPANIES_DUPLICATE_ALERT_DIALOG_DESCRIPTION:
		"E' stata rilevata almeno un'altra Azienda con la stessa partita IVA (visibile qui sotto). E' probabile che l'Azienda che stai aggiungendo sia il duplicato di un'anagrafica già presente. Per continuare comunque l'operazione utilizza il bottone \"Continua\" in fondo.",

	// #region Companies fields
	COMPANIES_ERP_CUSTOMER_ID: 'NAV ID Cliente: {id}',
	COMPANIES_ERP_SUPPLIER_ID: 'NAV ID Fornitore: {id}',
	COMPANIES_ERP_CONTACT_ID: 'NAV ID Contatto: {id}',
	COMPANIES_IMPORT_DATE: 'Data importazione: {date}',

	DETAILS_COMPANIES_FIELD_TITLE: 'Ragione sociale',
	DETAILS_COMPANIES_FIELD_ERP_CUSTOMER_ID: 'NAV ID Cliente',
	DETAILS_COMPANIES_FIELD_ERP_SUPPLIER_ID: 'NAV ID Fornitore',
	DETAILS_COMPANIES_FIELD_ERP_CONTACT_ID: 'NAV ID Contatto',
	DETAILS_COMPANIES_FIELD_STATUS: 'Stato Azienda',
	DETAILS_COMPANIES_FIELD_RELATION: 'Tipo Relazione Azienda',
	DETAILS_COMPANIES_FIELD_TYPE: 'Tipo Azienda',
	DETAILS_COMPANIES_FIELD_SUBTYPES: 'Sottotipi Azienda',
	DETAILS_COMPANIES_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_COMPANIES_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_COMPANIES_FIELD_REFERENCE: 'Referente Azienda',
	DETAILS_COMPANIES_FIELD_RATING: 'Valutazione',
	DETAILS_COMPANIES_FIELD_VAT: 'Partita IVA',
	DETAILS_COMPANIES_FIELD_TAXCODE: 'Codice fiscale',
	DETAILS_COMPANIES_FIELD_TAGS: 'Tag',
	DETAILS_COMPANIES_FIELD_WARNING: 'Warning',
	DETAILS_COMPANIES_FIELD_BLOCKED: 'Bloccato',
	DETAILS_COMPANIES_FIELD_PEC: 'PEC',
	DETAILS_COMPANIES_FIELD_LEGAL_FORM: 'Forma giuridica',
	DETAILS_COMPANIES_FIELD_ATECO: 'Codice Ateco',
	DETAILS_COMPANIES_FIELD_EMPLOYEES: 'Numero dipendenti',
	DETAILS_COMPANIES_FIELD_REVENUE: 'Fatturato annuale',
	DETAILS_COMPANIES_FIELD_ESTABLISHMENT_DATE: 'Data di costituzione',
	DETAILS_COMPANIES_FIELD_LANGUAGE: 'Lingua principale',
	DETAILS_COMPANIES_FIELD_DOMAIN: 'Dominio principale',
	DETAILS_COMPANIES_FIELD_PRICINGGROUP: 'Listino prezzi',
	DETAILS_COMPANIES_FIELD_DISCOUNTGROUP: 'Gruppo sconto',
	DETAILS_COMPANIES_FIELD_PAYMENTTERMS: 'Metodo di pagamento',
	DETAILS_COMPANIES_FIELD_PAYMENTMETHOD: 'Metodo di pagamento',
	DETAILS_COMPANIES_FIELD_SHIPPINGMETHOD: 'Metodo di spedizione',
	DETAILS_COMPANIES_FIELD_SHIPPINGAGENT: 'Spedizioniere',
	DETAILS_COMPANIES_FIELD_SDI: 'Codice SDI',
	DETAILS_COMPANIES_FIELD_CREDITLIMIT: 'Affidato',
	DETAILS_COMPANIES_FIELD_ADDRESS: 'Indirizzo',
	DETAILS_COMPANIES_FIELD_ADDRESS_CITY: 'Città',
	DETAILS_COMPANIES_FIELD_ADDRESS_ZIP: 'CAP',
	DETAILS_COMPANIES_FIELD_ADDRESS_DISTRICT: 'Provincia',
	DETAILS_COMPANIES_FIELD_ADDRESS_REGION: 'Regione',
	DETAILS_COMPANIES_FIELD_ADDRESS_COUNTRY: 'Nazione',
	DETAILS_COMPANIES_FIELD_ADDRESS_ZONE: 'Zona',
	DETAILS_COMPANIES_BUSINESS_CARD_SECTION: 'Biglietto da visita',
	DETAILS_COMPANIES_BUSINESS_CARD_SUBHEADER: 'Visualizza e modifica il biglietto da visita di questa Azienda',
	BUSINESS_CARD_FRONT: 'Fronte',
	BUSINESS_CARD_BACK: 'Retro',
	BUSINESS_CARD_NO_IMAGE: 'Nessuna immagine trovata',
	DETAILS_COMPANIES_FIELD_MARKETINGACTION: 'Azione di marketing padre',
	DETAILS_COMPANIES_FIELD_COMMERCIALCAMPAIGN: 'Campagna commerciale padre',
	DETAILS_COMPANIES_FIELD_LEADCHANNEL: 'Canale Lead',
	DETAILS_COMPANIES_FIELD_PARENT_COMPANY: 'Azienda padre',
	DETAILS_COMPANIES_FIELD_BROKER_COMPANY: 'Segnalatore - Azienda',
	DETAILS_COMPANIES_FIELD_BROKER_PERSON: 'Segnalatore - Persona',
	DETAILS_COMPANIES_FIELD_D_MODIFIED: 'Data modifica', // ORDER_BY
	// #endregion

	// #region Details Address section
	DETAILS_ADDRESS_SECTION: 'Indirizzo',
	DETAILS_ADDRESS_SUBHEADER: "Visualizza e modifica l'indirizzo",

	DETAILS_COMPANIES_REFRESH_COORDINATES: 'Ricalcola coordinate',
	// #endregion

	// #region Details Address section
	DETAILS_NAV_INFO_SECTION: 'Informazioni NAV',
	DETAILS_NAV_INFO_SUBHEADER: 'Visualizza le informazioni presenti su NAV',
	// #endregion

	// #region User Avatar
	COMPANIES_AVATAR_SECTION: 'Avatar',
	COMPANIES_AVATAR_SUBHEADER: "Visualizza o aggiorna l'avatar dell'Azienda",
	// #endregion

	// #region Tabs
	TAB_COMPANIES_ALL: 'Tutti',
	TAB_COMPANIES_CUSTOMERS: 'Clienti',
	TAB_COMPANIES_SUPPLIERS: 'Fornitori',
	TAB_COMPANIES_OTHERS: 'Altro',
	TAB_BUSINESS_CARD: 'Biglietti da visita',
	TAB_DUPLICATES: 'Duplicati',
	// #endregion

	// #region Creditsafe reports
	TAB_COMPANIES_CREDITSAFE: 'Report Creditsafe',

	DETAILS_COMPANIES_CREDITSAFE_SECTION: 'Report finanziari Creditsafe',
	COMPANIES_CREDITSAFE_LAST_UPDATE: 'Ultimo aggiornamento: {date}',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_NOTLINKED:
		'Per poter scaricare i report finanziari collega l\'Azienda ad un anagrafica di Credisafe tramite il bottone "Collega".',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_LINKED:
		'L\'Azienda è collegata correttamente all\'anagrafica di Creditsafe. È possibile scaricare i report finanziari tramite il bottone "Scarica report" o cambiare l\'anagrafica collegata tramite il bottone "Cambia collegamento".',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_DESCRIPTION_WARNING:
		"ATTENZIONE: sono necessarie la nazione e la partita IVA dell'Azienda per poter effettuare la ricerca.",

	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_TITLE: 'Formato del report',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_ORDINARY: 'Ordinario',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_ABBREVIATED: 'Abbreviato',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_CONSOLIDATED: 'Consolidato',
	DETAILS_COMPANIES_CREDITSAFE_SECTION_REPORT_FORMAT_MICRO: 'Micro',

	COMPANIES_CREDITSAFE_BUTTON_LINK: 'Collega',
	COMPANIES_CREDITSAFE_BUTTON_RELINK: 'Cambia collegamento',
	CREDITSAFE_DIALOG_SEARCH_TITLE: "Seleziona l'anagrafica di Creditsafe da collegare",
	CREDITSAFE_DIALOG_SEARCH_ERROR: "La nazione e la partita IVA dell'Azienda sono necessari per effetture la ricerca!",

	COMPANIES_CREDITSAFE_BUTTON_DOWNLOAD: 'Scarica report',
	CREDITSAFE_DIALOG_DOWNLOAD_TITLE: 'Come vuoi scaricare il report Creditsafe?',
	CREDITSAFE_DIALOG_DOWNLOAD_DESCRIPTION:
		'Utilizzando l\'opzione "Creditsafe" verrà scaricato il report direttamente dalla banca dati Creditsafe, consumando 1 credito. Invece selezionando l\'opzione "Server locale" verrano importati i dati già presenti nel database Perceptive, senza che vengano utilizzati crediti.',
	CREDITSAFE_DIALOG_DOWNLOAD_OPTION_CREDITSAFE: 'Creditsafe',
	CREDITSAFE_DIALOG_DOWNLOAD_OPTION_LOCAL: 'Server locale',
	CREDITSAFE_DIALOG_UPDATE_COMPANY_TITLE: "Vuoi aggiornare anche i seguenti campi dell'Azienda?",

	DETAILS_COMPANIES_CREDITSAFE_SECTION_INCOME_STATEMENT: 'CONTO ECONOMICO',
	CSFS_TOTALVALUEOFPRODUCTION: 'Totale valore della produzione',
	CSFS_OPERATINGREVENUES: 'Ricavi operativi',
	CSFS_CHANGEINWORKINPROGRESS: 'Variazione delle rimanenze di prodotti',
	CSFS_TOTALOTHERINCOMEANDREVENUES: 'Altri ricavi e proventi',
	CSFS_TOTALCOSTOFPRODUCTION: 'Totale costi di produzione',
	CSFS_PURCHASEOFGOODS: 'Costo per acquisti',
	CSFS_COSTOFSERVICES: 'Costo per servizi',
	CSFS_USEOFTHIRDPARTYASSETS: 'Costo per godimento di beni di terzi',
	CSFS_TOTALPAYROLLANDRELATEDCOSTS: 'Costo del personale',
	CSFS_CHANGESININVENTORIES: 'Variazione delle rimanenze di materie prime',
	CSFS_OTHEROPERATINGEXPENSES: 'Oneri diversi di gestione',
	CSFS_TOTALAMORTISATIONDEPRECIATIONANDWRITEDOWNS: 'Ammortamenti e svalutazioni',
	CSFS_EBITDA: 'Margine operativo lordo (EBITDA)',
	CSFS_EBIT: 'Risultato operativo (EBIT)',
	CSFS_TOTALFINANCIALINCOMEANDEXPENSE: 'Proventi e oneri finanziari',
	CSFS_TOTALVALUEADJUSTMENTSTOFINANCIALASSETSANDLIABILITIES: 'Rettifiche di attività/passività finanziarie',
	CSFS_PRETAXRESULT: 'Risultato prima delle imposte',
	CSFS_TOTALTAXESONTHEINCOMEFORTHEYEAR: "Imposte sul reddito d'esercizio",
	CSFS_PROFITORLOSSFORTHEYEAR: "Utile (Perdita) dell'esercizio",
	CSFS_CASHFLOWPL: 'Flusso di cassa',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_GROWTH_RATIOS: 'INDICI DI SVILUPPO',
	CSFS_CHANGEINREVENUESPERCENTAGE: 'Variazione dei ricavi',
	CSFS_CHANGEINTOTALVALUEOFPRODUCTIONPERCENTAGE: 'Variazione del valore della produzione',
	CSFS_CHANGEINTOTALASSETSPERCENTAGE: "Variazione dell'attivo",
	CSFS_CHANGEINSHAREHOLDERSEQUITYPERCENTAGE: 'Variazione del patrimonio netto',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_PROFITABILITY_RATIOS: 'INDICI DI REDDITIVITÀ',
	CSFS_RETURNONSALESPERCENTAGE: 'R.O.S. (Return on sales)',
	CSFS_RETURNONINVESTMENTPERCENTAGE: 'R.O.I. (Return on investment)',
	CSFS_RETURNONEQUITYPERCENTAGE: 'R.O.E. (Return on equity)',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_LIQUIDITY_RATIOS: 'INDICI DI LIQUIDITÀ',
	CSFS_CURRENTRATIO: 'Indice di disponibilità (Current ratio)',
	CSFS_ACIDTEST: 'Indice di liquidità immediata (Acid test)',
	CSFS_DEBTORDAYS: 'Giorni di credito clienti',
	CSFS_CREDITORDAYS: 'Giorni di credito fornitori',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_BALANCE_SHEET_ASSETS: 'STATO PATRIMONIALE: ATTIVO',
	CSFS_RECEIVABLESDUEFROMSHAREHOLDERS: 'Crediti verso soci',
	CSFS_INTANGIBLEFIXEDASSETS: 'Immobilizzazioni immateriali',
	CSFS_TANGIBLEFIXEDASSETS: 'Immobilizzazioni materiali',
	CSFS_FINANCIALFIXEDASSETS: 'Immobilizzazioni finanziarie',
	CSFS_TOTALFIXEDASSETS: 'Totale immobilizzazioni',
	CSFS_TOTALINVENTORIES: 'Totale rimanenze',
	CSFS_TOTALRECEIVABLES: 'Totale crediti',
	CSFS_DEBTORSDUEWITHIN1YEAR: 'di cui entro 12 mesi',
	CSFS_DUEFROMSUPPLIERSWITHIN1YEAR: 'di cui verso clienti nei 12 mesi',
	CSFS_PREPAIDTAX: 'imposte anticipate',
	CSFS_CURRENTFINANCIALASSETS: 'Attività finanziarie che non costituiscono immobilizzazioni',
	CSFS_LIQUIDASSETS: 'Totale disponibilità liquide',
	CSFS_TOTALCURRENTASSETS: 'Totale attivo circolante',
	CSFS_ACCRUEDINCOMEANDPREPAYMENTS: 'Ratei e riscontri attivi',
	CSFS_TOTALASSETS: 'Totale attivo',

	DETAILS_COMPANIES_CREDITSAFE_SECTION_BALANCE_SHEET_LIABILITIES: 'STATO PATRIMONIALE: PASSIVO',
	CSFS_SHAREHOLDERSEQUITY: 'Patrimonio netto',
	CSFS_SHARECAPITAL: 'Capitale sociale',
	CSFS_OTHERRESERVES: 'Altre riserve',
	CSFS_NETPROFITORLOSSFORTHEYEAR: "Utile (Perdita) dell'esercizio",
	CSFS_PROVISIONFORRISKSANDCHARGES: 'Fondi per rischi ed oneri',
	CSFS_PROVISIONFORSEVERANCEINDEMNITY: 'Fondo TFR',
	CSFS_TOTALPAYABLES: 'Totale debiti',
	CSFS_DUEWITHIN1YEAR: 'Debiti entro 12 mesi',
	CSFS_DUETOSUPPLIERSWITHIN1YEAR: 'di cui verso fornitori',
	CSFS_DUETOBANKWITHIN1YEAR: 'di cui verso banche',
	CSFS_DUEAFTER1YEAR: 'Debiti oltre 12 mesi',
	CSFS_DUETOSUPPLIERSAFTER1YEAR: 'di cui verso fornitori',
	CSFS_DUETOBANKAFTER1YEAR: 'di cui verso banche',
	CSFS_OTHERPAYABLES: 'Altri debiti',
	CSFS_ACCRUEDEXPENSESANDPREPAYMENTS: 'Ratei e risconti passivi',
	CSFS_TOTALLIABILITIES: 'Totale passivo e patrimonio netto',
	// #endregion

	// #region Atoka reports
	TAB_COMPANIES_ATOKA: 'Report Atoka',

	DETAILS_COMPANIES_ATOKA_SECTION: 'Report finanziari Atoka',
	COMPANIES_ATOKA_LAST_UPDATE: 'Ultimo aggiornamento: {date}',
	DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_NOTLINKED:
		'Per poter scaricare i report finanziari collega l\'Azienda ad un anagrafica di Credisafe tramite il bottone "Collega".',
	DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_LINKED:
		'L\'Azienda è collegata correttamente all\'anagrafica di Atoka. È possibile scaricare i report finanziari tramite il bottone "Scarica report" o cambiare l\'anagrafica collegata tramite il bottone "Cambia collegamento".',
	DETAILS_COMPANIES_ATOKA_SECTION_DESCRIPTION_WARNING:
		"ATTENZIONE: è necessaria la partita IVA dell'Azienda per poter effettuare la ricerca.",

	COMPANIES_ATOKA_BUTTON_LINK: 'Collega',
	COMPANIES_ATOKA_BUTTON_RELINK: 'Cambia collegamento',
	ATOKA_DIALOG_SEARCH_TITLE: "Seleziona l'anagrafica di Atoka da collegare",
	ATOKA_DIALOG_SEARCH_ERROR: "La nazione e la partita IVA dell'Azienda sono necessari per effetture la ricerca!",

	COMPANIES_ATOKA_BUTTON_DOWNLOAD: 'Scarica report',
	ATOKA_DIALOG_DOWNLOAD_TITLE: 'Come vuoi scaricare il report Atoka?',
	ATOKA_DIALOG_DOWNLOAD_DESCRIPTION:
		'Utilizzando l\'opzione "Atoka" verrà scaricato il report direttamente dalla banca dati Atoka, consumando 1 credito. Invece selezionando l\'opzione "Server locale" verrano importati i dati già presenti nel database Perceptive, senza che vengano utilizzati crediti.',
	ATOKA_DIALOG_DOWNLOAD_OPTION_ATOKA: 'Atoka',
	ATOKA_DIALOG_DOWNLOAD_OPTION_ATOKA_INFO: 'Servizio in Cloud',
	ATOKA_DIALOG_DOWNLOAD_OPTION_LOCAL: 'Server locale',
	ATOKA_DIALOG_UPDATE_COMPANY_TITLE: "Vuoi aggiornare anche i seguenti campi dell'Azienda?",

	DETAILS_COMPANIES_ATOKA_SECTION_INCOME_STATEMENT: 'CONTO ECONOMICO',
	ATFS_PRODUCTION: 'Valore della produzione',
	ATFS_REVENUE: 'Ricavi netti',
	ATFS_COSTS: 'Costi',
	ATFS_PURCHASES: 'Acquisti netti',
	ATFS_SERVICESANDTPGOODSCHARGES: 'Costi per servizi e godimento beni terzi',
	ATFS_STAFFCOSTS: 'Costo del lavoro',
	ATFS_RAWMATERIALSVARIATION: 'Variazione rimanenze materie prime, sussidiarie, merci',
	ATFS_MOL: 'Margine operativo lordo',
	ATFS_PROFIT: "Utile (perdita) dell'esercizio",
	ATFS_EBITDA: 'EBITDA',
	ATFS_ASSETS: 'Attivo',
	ATFS_CAPITALSTOCK: 'Capitale',
	ATFS_EQUITY: 'Patrimonio netto',
	ATFS_NETWORKINGCAPITAL: 'Capitale circolante',
	ATFS_NETFINANCIALPOSITION: 'Posizione finanziaria netta',
	// #endregion

	// #region Order notes
	DETAILS_HEADER_BUTTON_COMPANIES_ORDERS_NOTES: "Note Proposte d'Ordine",
	DIALOG_COMPANIES_ORDERS_NOTES_EDIT: "Modifica le note delle Proposte d'Ordine"
	// #endregion
};

export default locale;
